import { connect } from "react-redux";

import LocalizedLink from "../components/LocalizedLink";

const mapStateToProps = state => ({
  lng: state.locale.lng
});

export default connect(mapStateToProps)(LocalizedLink);



// WEBPACK FOOTER //
// ./src/containers/LocalizedLink.js